module.exports = __webpack_public_path__ + "img/artwork-coming-soon-bg.b6f3d5e4.png";